export { default, default as Overlay } from './Overlay'
export * as OverlayStyles from './styles/Overlay.style'

export type { OverlayProps } from './Overlay.types'
export type { StyledOverlayProps } from './styles/Overlay.style.types'
